import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
}

export const SEO: React.FC<SEOProps> = ({ 
  title = "Make Me Filer - Easy NTN & Tax Return Filing in Pakistan",
  description = "File your FBR Tax Returns easily and securely. Professional tax consultants across Pakistan offering top-rated services for corporate, individual, and overseas clients.",
  image = "https://www.makemefiler.com/assets/og-image.jpg", // Replace with actual absolute prod URL
  url = "https://www.makemefiler.com",
  type = "website"
}) => {
  // Always append brand name logically unless it's already there
  const fullTitle = title.includes("Make Me Filer") ? title : `${title} | Make Me Filer`;

  return (
    <Helmet>
      {/* Standard SEO */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />

      {/* Open Graph / Facebook / WhatsApp */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
    </Helmet>
  );
};
